import { type YDatabase } from '@databases/collab/y-database';
import { type MutableView } from '@databases/model/views/view';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

export function assertViewExists(
  ydb: YDatabase,
  viewId: string
): Result<MutableView, SdkError> {
  const view = ydb.viewsById[viewId];

  if (!view) {
    return err({
      type: 'STATE_ERROR',
      reason: 'VIEW_NOT_FOUND',
      message: `View '${viewId}' does not exist`,
    });
  }

  return ok(view);
}
